module.exports = __webpack_public_path__ + "static/media/carta_20.ffb4e5f1.jpg";